/**
 * Endpoint de health check ANMAT — backend real (proxy a riga-traza-v2).
 *
 * El polling lo configura `useAnmatStatus` en queries.ts (refetchInterval 10s).
 */

import { AnmatStatusSchema, type AnmatStatus } from '@/api/contracts/anmat-status';
import { apiFetch } from '@/api/http';

export async function getAnmatStatus(): Promise<AnmatStatus> {
  const data = await apiFetch<unknown>('/anmat/status', { auth: true });
  return AnmatStatusSchema.parse(data);
}
